import axios from 'axios';
import { absensiImageUrl, documentUrl, profileImageUrl } from './config';

const blobCache = new Map();

/**
 * Fetch media terproteksi (cookie JWT) → object URL.
 * Diperlukan karena <img src="https://api-..."> TIDAK mengirim cookie
 * cross-origin dengan andal (prod: zafu.* → api-zafu.* → 403).
 */
export const fetchMediaBlobUrl = async (absoluteUrl) => {
    if (!absoluteUrl) return '';
    const cached = blobCache.get(absoluteUrl);
    if (cached) return cached;

    const res = await axios.get(absoluteUrl, {
        responseType: 'blob',
        withCredentials: true,
    });
    const objectUrl = URL.createObjectURL(res.data);
    blobCache.set(absoluteUrl, objectUrl);
    return objectUrl;
};

export const absensiBlobUrl = (relativePath) =>
    fetchMediaBlobUrl(absensiImageUrl(relativePath));

export const profileBlobUrl = (filename) =>
    fetchMediaBlobUrl(profileImageUrl(filename));

export const documentBlobUrl = (filename) =>
    fetchMediaBlobUrl(documentUrl(filename));

/** Optional: revoke semua cache (mis. logout). */
export const clearMediaBlobCache = () => {
    for (const url of blobCache.values()) {
        try {
            URL.revokeObjectURL(url);
        } catch {
            // ignore
        }
    }
    blobCache.clear();
};
